export enum ActivityStreamOrganisationManagementEventType {
  Position = 'Position',
  OrganisationRecord = 'OrganisationRecord',
  Role = 'Role',
  EmployeeLineManagerRecord = 'EmployeeLineManagerRecord'
}
